module.exports = __webpack_public_path__ + "static/img/logo.ecc5065.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/logo.png
// module id = +RGQ
// module chunks = 1